import { render, staticRenderFns } from "./StudentCourseFile.vue?vue&type=template&id=542718d1&"
import script from "./StudentCourseFile.vue?vue&type=script&lang=js&"
export * from "./StudentCourseFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports